import { CreditDocuments } from '@interhyp/module-documents';
import React, { useMemo } from 'react';

import { COMMUNICATION_PLUGIN_ENABLED } from '../../../constants/env';
import { Navigation, NavItems } from '../../navigation/Navigation';
import '@interhyp/module-documents/esm/index.css';

export interface SubmissionDocumentsLegacyWrapperProps {
  submissionId: string;
  providerId: string;
}

export function SubmissionDocumentsLegacyWrapper({
  submissionId,
  providerId,
}: SubmissionDocumentsLegacyWrapperProps): JSX.Element {
  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/credit/summary`, translation: 'navigation.summary' },
      { to: `/credit/documents`, translation: 'navigation.documents' },
      ...(COMMUNICATION_PLUGIN_ENABLED
        ? [
            {
              to: `/credit/communication`,
              translation: 'navigation.communication',
            },
          ]
        : []),
    ];
  }, []);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <CreditDocuments submissionComponentId={submissionId} providerId={providerId} />
    </>
  );
}
